import { TextInfoModel } from './vo/text-info.model';
import { KYMW0700Component } from './kymw0700.component';

/**
 * 文字情報選択画面の値を管理するクラス
 *
 * @export KYMW0700Model
 * @class KYMW0700Model
 */
export class KYMW0700Model {

  kymw0700Component: KYMW0700Component;
  /**
   * Pコード
   */
  public pCode: string = <string>'PXXXXXX';

  /**
   * 商品文字情報種別
   */
  public textKindID: string = <string>'';

  /**
   * 商品名
   */
  public goodsName: string = <string>'テスト商品名';

  /**
   * 規格名
   */
  public guideStandardName: string = <string>'テスト規格名';

  /**
   * 文字情報一覧
   */
  public textInfoList: Array<any> = null;

  /**
   * アプリケーションタイトル
   */
  public titleValue: string = <string>'　';

  /**
   * DataGridのヘッダテキスト
   */
  public headerText: string = <string>'　';

  // バインド用変数
  public enabledSet: boolean = <boolean>false;

  /**
		 * サーバからの受信データにて商品文字情報を更新する
		 *
		 * @param serverData サーバからの受信データ
		 */
  public updateTextInfo(serverData: any): void {
    // 作業用変数
    const tempTextInfoList: Array<any> = new Array<any>();

    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // Pコードと商品付随文字情報IDを取得
      this.pCode = serverData.GoodsCode;	// Pコード
      this.textKindID = serverData.TextKindID;	// 商品付随文字情報ID

      // 画面タイトルとデータグリッドのヘッダテキストを設定
      this.titleValue = serverData.TextKindInfo + '選択';
      this.headerText = serverData.TextKindInfo;


      // サーバからの受信データの中で、商品付随文字情報が存在するか
      if (serverData.TextInfo != null) {
        // 商品付随文字情報が複数戻ってきていないか
        if (serverData.TextInfo.constructor === Array) {
          // 配列の長さ分ループする
          for (let i = Number(0); i < serverData.TextInfo.length; i++) {
            // Array<any>に追加するVOの生成
            const tempVO: TextInfoModel = new TextInfoModel;
            tempVO.stringValue = serverData.TextInfo[i].StringValue;	// 文字列
            tempVO.textKindNum = serverData.TextInfo[i].TextKindNum;	// 商品付随文字情報連番
            tempVO.dispNum = i + 1;	// 表示用連番(1からカウントする)

            // 選択フラグが1のときが「選択状態」である
            if (serverData.TextInfo[i].SelectValue != null && serverData.TextInfo[i].SelectValue === '1') {
              tempVO.selectedFlg = true; // 選択フラグ
            }
            tempTextInfoList.push(tempVO);
          }
        } else {
          // Array<any>に追加するVOの生成
          const tempVO: TextInfoModel = new TextInfoModel;
          tempVO.stringValue = serverData.TextInfo.StringValue;	// 文字列
          tempVO.textKindNum = serverData.TextInfo.TextKindNum;	// 商品付随文字情報連番
          tempVO.dispNum = 1;	// 表示用連番(1からカウントする)

          // 選択フラグが1のときが「選択状態」である
          if (serverData.TextInfo.SelectValue != null && serverData.TextInfo.SelectValue === '1') {
            tempVO.selectedFlg = true; // 選択フラグ
          }
          tempTextInfoList.push(tempVO);
        }
      }
    }

    this.textInfoList = tempTextInfoList;

    // 再描画を行う
    this.kymw0700Component.dg_TextInfoList.focus();
  }


  /**
   * 再描画時にフィルタリングを行う
   * 削除フラグがfalseのデータに関しては、表示しない
   * @param data フィルタリング対象データ
   * @return 表示可否
   *
   */
  public doFilter(data: any) {
    return data.deleteFlg;
  }
}
